module.exports = __webpack_public_path__ + "img/law2m-m@2.30636bc6.jpg";